import { Button, Icon } from "./ui";

export function MappingWorkspaceLoading({ label = "Loading mapping workspace" }: { readonly label?: string }) {
  return (
    <div className="ls-workspace-grid grid h-full min-h-0 grid-cols-1 overflow-hidden min-[761px]:grid-cols-[390px_minmax(0,1fr)] min-[1121px]:grid-cols-[390px_minmax(0,1fr)_400px]" role="status" aria-label={label}>
      <div className="hidden border-r border-[var(--shell-line)] bg-[var(--shell)] p-5 min-[761px]:block">
        <DarkSkeleton width="w-32" /><DarkSkeleton width="w-52" /><div className="mt-6 space-y-3"><DarkSkeleton /><DarkSkeleton /><DarkSkeleton width="w-4/5" /></div>
      </div>
      <div className="ls-document-surface border-x border-slate-300 p-6 sm:p-10"><Skeleton width="w-28" /><Skeleton width="mt-3 w-2/3" /><div className="mt-10 space-y-4"><Skeleton /><Skeleton /><Skeleton width="w-5/6" /></div></div>
      <div className="hidden border-l border-slate-200 bg-slate-50 p-5 min-[1121px]:block"><Skeleton width="w-36" /><div className="mt-6 space-y-3"><Skeleton /><Skeleton /><Skeleton /></div></div>
      <span className="sr-only">{label}…</span>
    </div>
  );
}

export function MappingWorkspaceMessage({ title, message, actionLabel, onAction }: {
  readonly title: string;
  readonly message: string;
  readonly actionLabel?: string;
  readonly onAction?: () => void;
}) {
  return (
    <div className="grid h-full place-items-center bg-[var(--paper)] px-6 py-12">
      <div className="w-full max-w-lg border border-slate-300 bg-white p-7 text-center shadow-[0_1px_0_rgba(15,23,42,0.05)]">
        <div className="ls-tech-label text-slate-500">Document mapping</div>
        <div className="mx-auto mt-4 grid h-10 w-10 place-items-center rounded border border-slate-300 bg-slate-50 text-slate-500"><Icon name="info" size={18} /></div>
        <h2 className="mt-4 text-xl font-semibold text-slate-950">{title}</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{message}</p>
        {actionLabel !== undefined && onAction !== undefined && <Button className="mt-5" variant="outline" onClick={onAction}>{actionLabel}</Button>}
      </div>
    </div>
  );
}

function Skeleton({ width = "w-full" }: { readonly width?: string }) {
  return <div aria-hidden="true" className={`h-3 rounded-sm bg-slate-200/80 ${width}`} />;
}

function DarkSkeleton({ width = "w-full" }: { readonly width?: string }) {
  return <div aria-hidden="true" className={`h-3 rounded-sm bg-slate-300/80 ${width}`} />;
}
